var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"GroupPush"}},[_c('appHeader',{attrs:{"hasBackTool":true,"targetRouterName":"sa-items-list-index"}}),_c('router-view',{staticClass:"content-body-hasFooter",staticStyle:{"padding-bottom":"90px"}}),_c('appSaFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }